import { render, staticRenderFns } from "./CollectionSimpleCard.vue?vue&type=template&id=bbdf35ea&scoped=true"
import script from "./CollectionSimpleCard.vue?vue&type=script&lang=js"
export * from "./CollectionSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./CollectionSimpleCard.vue?vue&type=style&index=0&id=bbdf35ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdf35ea",
  null
  
)

export default component.exports